import { render, staticRenderFns } from "./CreateOrganizationStep.vue?vue&type=template&id=227d0140"
import script from "./CreateOrganizationStep.vue?vue&type=script&lang=js"
export * from "./CreateOrganizationStep.vue?vue&type=script&lang=js"
import style0 from "./CreateOrganizationStep.vue?vue&type=style&index=0&id=227d0140&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports